// Barrel for all icon components. Each icon lives in its own file and is
// re-exported here; the UiIcon registry (ui/UiIcon) imports its glyphs from
// this module.

export { IconAperture } from './IconAperture';
export { IconArrowUpRight } from './IconArrowUpRight';
export { IconChevronLeft } from './IconChevronLeft';
export { IconChevronRight } from './IconChevronRight';
export { IconPlay } from './IconPlay';
export { IconArrowDown } from './IconArrowDown';
export { IconArrowLeft } from './IconArrowLeft';
export { IconChevronDown } from './IconChevronDown';
export { IconArrowRight } from './IconArrowRight';
export { IconCheck } from './IconCheck';
export { IconCross } from './IconCross';
export { IconFacebook } from './IconFacebook';
export { IconGithub } from './IconGithub';
export { IconInstagram } from './IconInstagram';
export { IconLinkedin } from './IconLinkedin';
export { IconMastodon } from './IconMastodon';
export { IconMenu } from './IconMenu';
export { IconPinterest } from './IconPinterest';
export { IconPlus } from './IconPlus';
export { IconTelegram } from './IconTelegram';
export { IconUpload } from './IconUpload';
export { IconTiktok } from './IconTiktok';
export { IconVimeo } from './IconVimeo';
export { IconWhatsapp } from './IconWhatsapp';
export { IconX } from './IconX';
export { IconXMark } from './IconXMark';
export { IconYoutube } from './IconYoutube';
